import { registerHandler } from "../handler";
import { isAffiliateWithoutTrial } from "../../userSegment";
import Cookies from "js-cookie";

declare const ire: any;

export default function registerHandlers() {
  registerHandler("init", (): void => {
    const searchParams = new URLSearchParams(window.location.search);
    const cid = searchParams.get("cid");
    const sp = searchParams.get("sp");
    if (cid && sp === "impact") {
      Cookies.set("ircid", cid, { expires: 30 });
    }
  });

  registerHandler("lead", ({ emailHashes, userId }) => {
    ire("identify", {
      customerId: userId,
      customerEmail: emailHashes.sha1,
    });
  });

  registerHandler(
    "purchase",
    async ({ order, plan, emailHashes, userId, promoCode }) => {
      const { discounted_plan_price, price } = plan;

      let subTotal = price || 0;

      if (isAffiliateWithoutTrial()) {
        subTotal = discounted_plan_price;
      }

      let text1 = "Trial";
      // All these params are applying when user subscribes with trial
      let category = "Trial";

      // Override in case the plan has no trial
      if (!plan.has_trial) {
        text1 = "Sale";
        category = "Subscribed";
      }

      const payload = {
        orderId: order.subscriptionId,
        customerId: userId,
        customerStatus: "New",
        customerEmail: emailHashes.sha1,
        currencyCode: plan.currency,
        text1,
        orderPromoCode: promoCode.promoCodeApplied,
        items: [
          {
            subTotal,
            category,
            sku: plan.braintree_id,
            quantity: 1,
          },
        ],
      };

      const conversionTag = category === "Trial" ? 15420 : 32431;
      ire("trackConversion", conversionTag, payload, {
        verifySiteDefinitionMatch: true,
      });
    }
  );

  registerHandler(
    "HMPurchase",
    async ({ order, plan, emailHashes, userId, promoCode }) => {
      const { discounted_plan_price } = plan;

      const subTotal = discounted_plan_price || 0;
      const cid = Cookies.get("ircid") || "";

      let category = "Trial";
      if (!plan.has_trial) {
        category = "Subscribed";
      }

      const payload = {
        orderId: order.subscriptionId,
        customerId: userId,
        clickId: cid,
        customerStatus: "New",
        customerEmail: emailHashes.sha1,
        currencyCode: plan.currency,
        orderPromoCode: promoCode.promoCodeApplied,
        items: [
          {
            subTotal,
            category,
            sku: plan.braintree_id,
            quantity: 1,
          },
        ],
      };
      const conversionTag = category === "Trial" ? 26974 : 26975;
      ire("trackConversion", conversionTag, payload, {
        verifySiteDefinitionMatch: true,
      });
    }
  );
}
